import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { ExternalLink } from 'lucide-react';

export const PrivacyPolicyModal = ({ handleChange, setShowPrivacyModal, showPrivacyModal, privacyPolicy }) => (
      <Dialog open={showPrivacyModal} onOpenChange={setShowPrivacyModal}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl">Privacy Policy & Data Protection</DialogTitle>
            <DialogDescription>
              Digital Personal Data Protection Act (DPDPA) 2023 Compliance
            </DialogDescription>
          </DialogHeader>

          {privacyPolicy && (
            <div className="space-y-6 py-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-slate-700">
                  <strong>Version:</strong> {privacyPolicy.version} | 
                  <strong className="ml-2">Last Updated:</strong> {privacyPolicy.last_updated}
                </p>
              </div>

              <p className="text-slate-700 leading-relaxed">
                {privacyPolicy.content.introduction}
              </p>

              <div className="space-y-4">
                {privacyPolicy.content.sections.map((section, idx) => (
                  <div key={section.heading} className="border-l-4 border-blue-500 pl-4">
                    <h3 className="font-semibold text-slate-900 mb-2">{section.heading}</h3>
                    <p className="text-sm text-slate-700 leading-relaxed">{section.content}</p>
                  </div>
                ))}
              </div>

              {privacyPolicy.external_policy_url && (
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
                  <p className="text-sm text-slate-700 mb-2">
                    For the complete privacy policy, visit:
                  </p>
                  <a 
                    href={privacyPolicy.external_policy_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline flex items-center gap-1 text-sm font-medium"
                  >
                    {privacyPolicy.external_policy_url} <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              )}
            </div>
          )}

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button
              onClick={() => setShowPrivacyModal(false)}
              variant="outline"
            >
              Close
            </Button>
            <Button
              onClick={() => {
                handleChange('consent_given', true);
                setShowPrivacyModal(false);
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              I Understand & Accept
            </Button>
          </div>
        </DialogContent>
      </Dialog>
);
